import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as moment from 'moment'
import { phoneRegExp } from '../../../../constants/constants'
import { Formik } from 'formik'
import * as yup from 'yup'
import {
  Button,
  Row,
  Col,
  Modal,
  DatePicker,
  Tag,
  Input,
  Form,
  Select,
  message,
  Spin,
  Upload,
  Icon,
} from 'antd'
import axios from 'axios'
import AuthorizeComponent from '../../../auth/components/AuthorizeComponent'
import { helper_convertDateformat } from '../../../../lib/helper'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import ChangePasswordModal from 'modules/shared/components/ChangePasswordModal'

const InputGroup = Input.Group
const { confirm } = Modal
const { MonthPicker, RangePicker } = DatePicker
const { Option } = Select
const { Item } = Form
const FormItem = Item
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: { oldPassword: '', password: '', confirmPassword: '' },
      data_profile: {
        company_name: '',
        username: '',
        employee_code: '',
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        expired_at: '',

        // รูปลายเซ็น
        img_signature_id: null,
        img_signature: [],
        isEditImage: false,
      },
      ModalText: 'Content of the modal',
      disable: true,
      disableSignatureImg: true,
      visible: false,
      loading: false,

      previewVisible: false,
      previewImage: '',
      fileList: [],

      isEdit: false,
    }

    this.formik = null
  }

  showModal = () => {
    this.setState({
      visible: true,
    })
  }

  disableFalse = () => {
    let user_type = this.props.auth.profile.user_type
    this.setState({
      disable: user_type == 1 ? false : true,
      disableSignatureImg: false,
      isEdit: true,
    })
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    })
  }

  componentDidMount() {
    this.setState({ loading: true }, () => {
      this.loadDataProfile()
    })
  }

  loadDataProfile() {
    let self = this
    axios
      .get(`${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-data-profile`, {
        headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
      })
      .then(function(response) {
        let img_signature = []
        if (response.data.data.signature_path) {
          img_signature.push({
            uid: response.data.data.signature_id,
            name: response.data.data.signature_name,
            status: 'done',
            url: response.data.data.signature_path,
          })
        }

        self.setState(
          {
            data_profile: {
              ...self.state.data_profile,
              company_name: self.props.auth.profile.company_name,
              username: response.data.data.username,
              employee_code: response.data.data.code,
              firstname: response.data.data.firstname,
              lastname: response.data.data.lastname,
              phone: response.data.data.phone,
              email: response.data.data.email,
              expired_at: response.data.data.expired_at,

              // รูปลายเซ็น
              img_signature_id: response.data.data.signature_id || null,
              img_signature: img_signature,
              isEditImage: false,
            },
            fileList: img_signature,
            loading: false,
            disable: true,
            disableSignatureImg: true,
            isEdit: false,
          },
          () => {}
        )
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  componentWillUnmount() {}

  showConfirm = (values) => {
    let self = this
    confirm({
      title: (
        <LangContext.Consumer>
          {(i18n) => i18n.d.doYouWantToEditTheseItems}
        </LangContext.Consumer>
      ),
      content: (
        <LangContext.Consumer>
          {(i18n) => i18n.c.confirmToEditThisItem}
        </LangContext.Consumer>
      ),
      okText: (
        <LangContext.Consumer>{(i18n) => i18n.o.ok}</LangContext.Consumer>
      ),
      cancelText: (
        <LangContext.Consumer>{(i18n) => i18n.c.cancel}</LangContext.Consumer>
      ),
      onOk() {
        self.handleSubmit(values)
      },
      onCancel() {},
    })
  }

  handleSubmit = (values) => {
    let self = this

    this.setState({ loading: true })

    let user_type = this.props.auth.profile.user_type
    if (user_type == 1) {
      axios
        .post(
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/change-profile`,
          {
            username: values.username,
            employee_code: values.employee_code,
            firstname: values.firstname,
            lastname: values.lastname,
            phone: values.phone,
            email: values.email,
          },
          {
            headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
          }
        )
        .then(function(response) {
          if (response.data.status == 'fail' && response.data.errors) {
            message.error(i18n[self.props.language].u.updateFail)
            self.setState({ loading: false })
          } else if (response.data.status == 'fail_username') {
            Modal.warning({
              title: response.data.msg,
            })
            self.setState({ loading: false })
          } else {
            message.success(i18n[self.props.language].u.updateSuccess)

            // อัพเดทรูปภาพลายเซ็น
            self.handleUploadSignatureImage(values)
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    } else {
      // อัพเดทรูปภาพลายเซ็น
      this.handleUploadSignatureImage(values)
    }
  }

  handleUploadSignatureImage = (values) => {
    let self = this

    if (values.img_signature_id) {
      // มีข้อมูลเดิมอยู่แล้ว
      // ถ้ามีการแก้ไขรูปภาพ
      if (values.isEditImage) {
        let formData = new FormData()
        formData.append('id', values.img_signature_id)
        formData.append('updated_by', this.props.auth.profile.id)

        let img_signature = values.img_signature
        if (img_signature.length > 0) {
          formData.append('files', img_signature[0].originFileObj)
        } else {
          formData.append('files', null) // ถ้าส่ง null ให้ลบรูปภาพ
        }

        axios
          .post(
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/profile-update`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${this.props.auth.accessToken}`,
                'Content-Type': 'multipart/form-data',
              },
            }
          )
          .then(function(response) {
            if (response.data.status == 'success') {
              message.success(
                `${i18n[self.props.language].s.signatureImage} ${
                  i18n[self.props.language].u.updateSuccess
                }`
              )
              self.loadDataProfile()
            } else {
              message.error(
                `${i18n[self.props.language].s.signatureImage} ${
                  i18n[self.props.language].u.updateFail
                }`
              )
            }
          })
          .catch(function(error) {
            console.log(error)
          })
          .finally(() => {
            self.setState({ loading: false })
          })
      } else {
        // ไม่มีการแก้ไขรูปภาพ
        self.setState({ loading: false })
        self.loadDataProfile()
      }
    } else {
      // ไม่มีข้อมูลเดิม
      // ให้เพิ่มรูปภาพ
      if (values.img_signature.length > 0) {
        let formData = new FormData()
        formData.append('files', values.img_signature[0].originFileObj)
        formData.append('img_name', values.username)
        formData.append('companies_id', this.props.auth.profile.company_id)
        formData.append('m_user_id', this.props.auth.profile.id)
        formData.append('created_by', this.props.auth.profile.id)
        formData.append('updated_by', this.props.auth.profile.id)

        axios
          .post(
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/profile-insert`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${this.props.auth.accessToken}`,
                'Content-Type': 'multipart/form-data',
              },
            }
          )
          .then(function(response) {
            if (response.data.status == 'success') {
              message.success(
                `${i18n[self.props.language].s.signatureImage} ${
                  i18n[self.props.language].i.insertSuccess
                }`
              )

              self.loadDataProfile()
            } else {
              message.error(
                `${i18n[self.props.language].s.signatureImage} ${
                  i18n[self.props.language].i.insertFail
                }`
              )
            }
          })
          .catch(function(error) {
            console.log(error)
          })
          .finally(() => {
            self.setState({ loading: false })
          })
      } else {
        self.setState({ loading: false })
        self.loadDataProfile()
      }
    }
  }

  handleCancelEditProfile = () => {
    this.setState(
      {
        disable: true,
        disableSignatureImg: true,
        isEdit: false,
        data_profile: {
          ...this.state.data_profile,
          company_name: this.props.auth.profile.company_name,
          username: this.props.auth.profile.username,
          employee_code: this.props.auth.profile.employee_code,
          firstname: this.props.auth.profile.firstname,
          lastname: this.props.auth.profile.lastname,
          phone: this.props.auth.profile.phone,
          email: this.props.auth.profile.email,
          expired_at: this.props.auth.profile.expired_at,

          // รูปลายเซ็น
          isEditImage: false,
        },
        loading: true,
      },
      () => {
        this.loadDataProfile()
      }
    )
  }

  // upload รูป dummy
  dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('success')
    }, 0)
  }

  // ดึงข้อมูลรูปภาพ
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject()
    })
  }

  // แสดงรูปตัวอย่าง
  handlePreviewImage = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj)
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    })
  }

  // ปิด modal แสดงรูปตัวอย่าง
  handleClosePreviewImage = () => this.setState({ previewVisible: false })

  // เพิ่มรูปเข้าไปใน fileList
  handleChangeUploadImage = ({ file, fileList }) => {
    let self = this
    if (file.status === 'removed') {
      // กรณีลบรูปออกจาก fileList
      this.setState({ fileList }, () => {
        this.formik.setFieldValue('img_signature', this.state.fileList)
      })
    } else if (file.status === 'uploading') {
      // *กรณีเพิ่มรูปเข้าไปใน fileList
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        message.error(i18n[this.props.language].o.onlyImageCanBeUploaded)

        return
      }

      // ไม่เกิน 2 MB
      const isLt2M = file.size / 1024 <= 2048
      if (!isLt2M) {
        message.error(
          `${
            i18n[this.props.language].a.appropriateImageFileSizeNoMoreThan
          } 2 MB`
        )

        return
      }

      if (isJpgOrPng && isLt2M) {
        this.setState({ fileList }, () => {
          this.formik.setFieldValue('img_signature', this.state.fileList)
        })
      }

      // !เช็คขนาดรูป ยังไม่ได้ใช้เขียนไว้ก่อน
      // let img = new Image()
      // img.src = window.URL.createObjectURL(file.originFileObj)
      // img.onload = function() {
      //   if (img.width > 1440 || img.height > 480) {
      //     message.error(
      //       `${
      //         i18n[self.props.language].a.appropriateImageSizeNoMoreThan
      //       } 1440 x 480`
      //     )
      //     return
      //   } else {
      //     self.setState(
      //       {
      //         fileList: [
      //           {
      //             ...file,
      //             status: 'done',
      //           },
      //         ],
      //       },
      //       () => {
      //         self.formik.setFieldValue('img_signature', self.state.fileList)
      //       }
      //     )
      //   }
      // }
    }
  }

  render() {
    let user_type = this.props.auth.profile.user_type
    let dataVisibilityNode = this.props.auth.profile.data_visibility_node
    dataVisibilityNode = JSON.parse(dataVisibilityNode)

    if (dataVisibilityNode.length == 0) {
      dataVisibilityNode = [{ name: this.props.auth.profile.company_name }]
    }

    return (
      <Fragment>
        <LangContext.Consumer>
          {(i18n) => (
            <Formik
              enableReinitialize={true}
              initialValues={this.state.data_profile}
              validationSchema={
                this.state.disable == false
                  ? yup.object().shape({
                      username: yup.string().required(i18n.r.require),
                      firstname: yup.string().required(i18n.r.require),
                      firstname: yup.string().required(i18n.r.require),
                      phone: yup
                        .string()
                        .min(8, i18n.t.tooShort)
                        .max(20, i18n.t.tooLong)
                        .matches(phoneRegExp, `${i18n.i.invalidData}`)
                        .required(i18n.r.require),
                    })
                  : null
              }
              onSubmit={(values, actions) => {
                this.showConfirm(values, actions)
              }}
              ref={(formik) => (this.formik = formik)}
              render={({
                values,
                errors,
                status,
                handleBlur,
                touched,
                handleSubmit,
                setFieldValue,
              }) => (
                <Spin spinning={this.state.loading}>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                        <Form.Item
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.c.company}
                            </LangContext.Consumer>
                          }
                          style={{ marginBottom: '0px' }}
                        >
                          <Input
                            type='Text'
                            name='company'
                            value={values.company_name}
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                        <Form.Item
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.u.userName}
                            </LangContext.Consumer>
                          }
                          required={true}
                          validateStatus={
                            touched.username && errors.username
                              ? 'warning'
                              : undefined
                          }
                          help={
                            touched.username && errors.username
                              ? errors.username.substr(
                                  errors.username.indexOf(' ') + 1
                                )
                              : undefined
                          }
                          style={{ marginBottom: '0px' }}
                        >
                          <Input
                            type='Text'
                            name='username'
                            value={values.username}
                            disabled={this.state.disable}
                            onChange={(e) => {
                              setFieldValue('username', e.target.value)
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <FormItem
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.e.employeeID}
                            </LangContext.Consumer>
                          }
                          style={{ marginBottom: '0px' }}
                        >
                          <Input
                            type='Text'
                            name='employee_ID'
                            autoComplete='off'
                            value={values.employee_code}
                            disabled={this.state.disable}
                            onChange={(e) => {
                              setFieldValue('employee_code', e.target.value)
                            }}
                          />
                        </FormItem>
                      </Col>

                      <Col xs={0} sm={1} md={1} lg={1} xl={1}></Col>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.f.firstName}
                            </LangContext.Consumer>
                          }
                          style={{ marginBottom: '0px' }}
                          required={true}
                          validateStatus={
                            touched.firstname && errors.firstname
                              ? 'warning'
                              : undefined
                          }
                          help={
                            touched.firstname && errors.firstname
                              ? errors.firstname.substr(
                                  errors.firstname.indexOf(' ') + 1
                                )
                              : undefined
                          }
                        >
                          <Input
                            type='Text'
                            name='firstname'
                            autoComplete='off'
                            value={values.firstname}
                            disabled={this.state.disable}
                            onChange={(e) => {
                              setFieldValue('firstname', e.target.value)
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={0} sm={1} md={1} lg={1} xl={1}></Col>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.l.lastName}
                            </LangContext.Consumer>
                          }
                          style={{ marginBottom: '0px' }}
                          required={true}
                          validateStatus={
                            touched.lastname && errors.lastname
                              ? 'warning'
                              : undefined
                          }
                          help={
                            touched.lastname && errors.lastname
                              ? errors.lastname.substr(
                                  errors.lastname.indexOf(' ') + 1
                                )
                              : undefined
                          }
                        >
                          <Input
                            type='Text'
                            name='lastname'
                            autoComplete='off'
                            value={values.lastname}
                            disabled={this.state.disable}
                            onChange={(e) => {
                              setFieldValue('lastname', e.target.value)
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={0} sm={1} md={1} lg={1} xl={1}></Col>
                    </Row>

                    <Row>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <FormItem
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.p.phoneNumber}
                            </LangContext.Consumer>
                          }
                          style={{ marginBottom: '0px' }}
                          required={true}
                          validateStatus={
                            touched.phone && errors.phone
                              ? 'warning'
                              : undefined
                          }
                          help={
                            touched.phone && errors.phone
                              ? errors.phone.substr(
                                  errors.phone.indexOf(' ') + 1
                                )
                              : undefined
                          }
                        >
                          <Input
                            type='Text'
                            name='tel'
                            value={values.phone}
                            disabled={this.state.disable}
                            onChange={(e) => {
                              setFieldValue('phone', e.target.value)
                            }}
                          />
                        </FormItem>
                      </Col>

                      <Col xs={0} sm={1} md={1} lg={1} xl={1}></Col>

                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <FormItem
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.e.email}
                            </LangContext.Consumer>
                          }
                          style={{ marginBottom: '0px' }}
                        >
                          <Input
                            type='Text'
                            name='email'
                            autoComplete='off'
                            value={values.email}
                            // readOnly={true}
                            disabled={this.state.disable}
                            onChange={(e) => {
                              setFieldValue('email', e.target.value)
                            }}
                          />
                        </FormItem>
                      </Col>
                      <Col xs={0} sm={1} md={1} lg={1} xl={1}></Col>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.u.userExpireAt}
                            </LangContext.Consumer>
                          }
                        >
                          <Input
                            value={helper_convertDateformat(
                              values.expired_at,
                              'YYYY-MM-DD HH:mm:ss',
                              'DD/MM/YYYY HH:mm'
                            )}
                            // readOnly={true}
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <Form.Item
                          label={
                            <LangContext.Consumer>
                              {(i18n) => i18n.d.dataVisibility}
                            </LangContext.Consumer>
                          }
                        >
                          {dataVisibilityNode.map((ele) => (
                            <Tag>{ele.name}</Tag>
                          ))}
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* อัปโหลดรูปลายเซ็น */}
                    <Row>
                      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                        <FormItem
                          label={i18n.s.signatureImage}
                          validateStatus={
                            touched.img_signature &&
                            errors.img_signature &&
                            'error'
                          }
                          help={touched.img_signature && errors.img_signature}
                        >
                          <div>
                            <Upload
                              accept='image/*'
                              name='img_signature'
                              listType='picture-card'
                              fileList={this.state.fileList}
                              customRequest={this.dummyRequest}
                              onPreview={this.handlePreviewImage}
                              onChange={(info) => {
                                this.handleChangeUploadImage(info)
                                setFieldValue('isEditImage', true)
                              }}
                              showUploadList={{
                                showPreviewIcon: true,
                                showRemoveIcon: !this.state.disableSignatureImg,
                              }}
                              disabled={this.state.disableSignatureImg}
                            >
                              {this.state.fileList.length >= 1 ? null : this
                                  .state.disableSignatureImg ? (
                                <div>
                                  <div className='ant-upload-text'>
                                    {i18n.n.noData}
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <Icon type='plus' />
                                  <div className='ant-upload-text'>
                                    {i18n.u.upload}
                                  </div>
                                </div>
                              )}
                            </Upload>
                          </div>
                          {!this.state.disableSignatureImg && (
                            <div>
                              <span style={{ color: 'red', fontSize: '12px' }}>
                                {`${i18n.a.appropriateImageFileSizeNoMoreThan} 2 MB`}
                              </span>
                            </div>
                          )}

                          {/* <div>
                            <span style={{ color: 'red', fontSize: '12px' }}>
                              {`${i18n.a.appropriateImageSizeNoMoreThan} 840 x 480`}
                            </span>
                          </div> */}
                        </FormItem>
                      </Col>
                    </Row>

                    <br />

                    {this.state.isEdit ? (
                      <Row>
                        <Col sm={24} md={6} lg={6} xl={6}>
                          <Form.Item>
                            <Button onClick={this.handleCancelEditProfile}>
                              <LangContext.Consumer>
                                {(i18n) => i18n.c.cancel}
                              </LangContext.Consumer>
                            </Button>
                            <Button
                              style={{ marginLeft: '5px' }}
                              type='primary'
                              htmlType='submit'
                            >
                              <LangContext.Consumer>
                                {(i18n) => i18n.s.save}
                              </LangContext.Consumer>
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col sm={24} md={6} lg={6} xl={6}>
                          <Form.Item>
                            <Button type='primary' onClick={this.disableFalse}>
                              <LangContext.Consumer>
                                {(i18n) => i18n.e.editProfile}
                              </LangContext.Consumer>
                            </Button>
                            {user_type == 1 && this.state.disable == true && (
                              <Button
                                className='profile-change-password-button'
                                style={{ marginLeft: '5px' }}
                                onClick={this.showModal}
                              >
                                <LangContext.Consumer>
                                  {(i18n) => i18n.c.changePassword}
                                </LangContext.Consumer>
                              </Button>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                  </Form>
                </Spin>
              )}
            />
          )}
        </LangContext.Consumer>

        {/* same modal as the Header password-expiry banner */}
        <ChangePasswordModal
          visible={this.state.visible}
          onClose={this.handleCancel}
          accessToken={this.props.auth.accessToken}
        />

        {/* preview image */}
        <Modal
          visible={this.state.previewVisible}
          footer={null}
          onCancel={this.handleClosePreviewImage}
        >
          <div style={{ marginTop: '20px' }}>
            <img
              alt='preview_image'
              style={{ width: '100%' }}
              src={this.state.previewImage}
            />
          </div>
        </Modal>
      </Fragment>
    )
  }
}

export default connect(
  ({ auth, ui: { language } }) => ({
    auth,
    language,
  }),
  {}
)(Index)
